export function setPreloader(state, preloader){
    state.preloader = preloader
}



// WEBPACK FOOTER //
// ./src/modules/receivable/mutations.js